import { Quest } from "./types";

export const sortQuestsByVisibility = <
  T extends Pick<Quest, "flash" | "hidden">
>(
  quests: T[],
  isOrganizer: boolean,
  isCompleted: (quest: T) => boolean = () => false
): T[] => [
  ...quests.filter((quest) => quest.flash && !quest.hidden),
  ...quests.filter((quest) => !quest.flash && !quest.hidden),
  ...quests.filter(
    (quest) => quest.hidden && (isOrganizer || isCompleted(quest))
  ),
];
